/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPrompt.vue?vue&type=template&id=df251988&scoped=true"
import script from "./popPrompt.vue?vue&type=script&lang=js"
export * from "./popPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df251988",
  null
  
)

export default component.exports